// extracted by mini-css-extract-plugin
export default {"arrow_btns":"VerticalSection_arrow_btns__2aYOi"};